import { createFileRoute } from "@tanstack/react-router";

import { CoachProductAutomationPage } from "src/pages/CoachProductAutomationPage";

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/$automationId/",
)({
  component: CoachProductAutomationPage,
  ssr: true,
});
